import { tokens } from 'src/design-system';

export const SEShippingLineSizeTabsStyles = () => ({
  container: {
    width: '100%',
  },
  tabLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacing.xs,
  },
  tabSelectedIcon: {
    color: tokens.colors.success,
    fontSize: tokens.fontSize.body,
  },
  /** Warning shown when the current per-size picks span more than one Shipping Line vendor. */
  vendorMismatchNote: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.error,
    backgroundColor: tokens.colors.highlightYellow,
    border: `1px solid ${tokens.colors.warning}`,
    borderRadius: tokens.radius.md,
    padding: `${tokens.spacing.xs}px ${tokens.spacing.sm}px`,
    marginBottom: tokens.spacing.sm,
  },
});
